'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _session = require('redux/modules/session');

exports.default = function (store) {
  var requireLogin = function requireLogin(nextState, replace, cb) {
    function checkAuth() {
      var isLoggedIn = store.getState().session.isLoggedIn;
      if (!isLoggedIn) {
        var pathName = nextState.location.pathname;
        var query = nextState.location.$searchBase.search || '';
        if (nextState.location.pathname.match(/^\/booking\/new/)) {
          cb();
          return;
        }
        var encodedPath = encodeURIComponent('' + (pathName + query));
        replace('/?login=true&redirect=' + encodedPath);
      }
      cb();
    }
    // checkAuth();
    if (!(0, _session.isUserDataLoaded)(store.getState())) {
      store.dispatch((0, _session.loadUserData)()).then(checkAuth);
    } else {
      checkAuth();
    }
  };

  /**
   * Please keep routes in alphabetical order
   */
  if (typeof require.ensure !== 'function') require.ensure = function (deps, cb) {
    return cb(require);
  };

  return {
    path: '/',
    component: require('./containers/App/App'),
    /* Home (main) route */
    indexRoute: {
      component: require('./containers/Home/Home')
    },
    childRoutes: [{
      /* Routes requiring login */
      onEnter: requireLogin,
      childRoutes: [{
        path: 'booking/:id',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/Payment/Payment'));
          }, 'booking');
        }
      }, {
        path: 'booking/:id/success',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/Payment/PaymentSuccess'));
          }, 'payment-success');
        }
      },
      // {
      //   path: 'booking/:id/complete',
      //   getComponent(nextState, cb) {
      //     require.ensure([], (require) =>
      //       cb(null, require('./containers/Booking/Booking')));
      //   }
      // },
      {
        path: 'dashboard',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/Dashboard/Dashboard'));
          }, 'dashboard');
        }
      }, {
        path: 'dashboard/message-template',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/MessageTemplate/MessageTemplate'));
          }, 'message-template');
        }
      }, {
        path: 'dashboard/profile',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/Dashboard/Profile'));
          }, 'd-profile');
        }
      }, {
        path: 'dashboard/verification',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/Dashboard/Verification'));
          }, 'd-verification');
        }
      }, {
        path: 'dashboard/settings',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/Dashboard/Settings'));
          }, 'd-setting');
        }
      }, {
        path: 'dashboard/availability',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/Dashboard/Availability'));
          }, 'd-availability');
        }
      }, {
        path: 'dashboard/referral',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/Referral/Referral'));
          }, 'd-referral');
        }
      }, {
        path: 'dashboard/peer-review',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/PeerReview/PeerReview'));
          }, 'd-peer-review');
        }
      }, {
        path: 'dashboard/listing/:id',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/ListTrip/ListTrip'));
          }, 'd-listing');
        }
      }, {
        path: 'dashboard/listing',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/ListTrip/Trips'));
          }, 'd-listings');
        }
      }, {
        path: 'dashboard/booking',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/Dashboard/BookingList'));
          }, 'd-bookings');
        }
      }, {
        path: 'dashboard/booking/:id',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/Booking/Booking'));
          }, 'd-booking');
        }
      }, {
        path: 'dashboard/wallet',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/Dashboard/Wallet'));
          }, 'd-wallet');
        }
      }, {
        path: 'dashboard/service',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/Dashboard/Service'));
          }, 'd-service');
        }
      }, {
        path: 'swap-request/:id',
        getComponent: function getComponent(nextState, cb) {
          require.ensure([], function (require) {
            return cb(null, require('./containers/Swap/LxSwapRequest'));
          }, 'lx-swap-request');
        }
      }]
    }, {
      path: 'pay/:amount/:ref',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Payment/ExtraCharge'));
        }, 'pay-extra');
      }
    }, {
      path: 'affiliate',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Affiliate/Affiliate'));
        }, 'affiliate');
      }
    }, {
      path: 'buffet',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Buffet/Buffet'));
        }, 'buffet');
      }
    }, {
      path: 'buffet/:package',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Buffet/BuffetStep2'));
        }, 'buffet2');
      }
    }, {
      path: 'customize(/:slug)',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Customize/Customize'));
        }, 'customize');
      }
    }, {
      path: 'thumbnail/:slug',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Thumbnail/Thumbnail'));
        }, 'thumbnail');
      }
    }, {
      path: 'career',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Career/Career'));
        }, 'career');
      }
    }, {
      path: 'local-expert-benefits',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/LocalExpertBenefits/LocalExpertBenefits'));
        }, 'lx-benefits');
      }
    }, {
      path: 'local-expert/:slug',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/LocalExpertProfile/LocalExpertProfile'));
        }, 'local-expert');
      }
    }, {
      path: 'local-expert/preview/:slug',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/LocalExpertProfile/LocalExpertProfile'));
        }, 'local-expert-preview');
      }
    }, {
      path: 'trip/:slug',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/TripDetail/TripDetail'));
        }, 'trip');
      }
    }, {
      path: 'trip/preview/:slug',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/TripDetail/TripDetail'));
        }, 'trip-preview');
      }
    }, {
      path: 'inspiration',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Inspirations/Inspirations'));
        }, 'inspirations');
      }
    }, {
      path: 'inspiration/:slug',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Inspirations/InspirationDetail'));
        }, 'inspiration');
      }
    }, {
      path: 'email/confirm/:token',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Confirm/ConfirmEmail'));
        }, 'email-confirm');
      }
    }, {
      path: 'mobileconnect/callback',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/MobileConnect/MobileConnectCallback'));
        }, 'mobileconnect');
      }
    }, {
      path: 'weibo/callback',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Weibo/WeiboCallback'));
        }, 'weibo');
      }
    }, {
      path: 'digi-lucky-draw',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Digi/DigiLuckyDraw'));
        }, 'digi-lucky-draw');
      }
    }, {
      path: 'digi',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Digi/Digi'));
        }, 'digi');
      }
    }, {
      path: 'dtac',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Dtac/Dtac'));
        }, 'dtac');
      }
    }, {
      path: 'f/:path',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Form/Form'));
        }, 'form');
      }
    }, {
      path: 'to/:location',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/SearchTrips/Search'));
        }, 'goto');
      }
    }, {
      path: 'search/:location',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/SearchTrips/Search'));
        }, 'search');
      }
      // }, {
      //   path: 'booking-payment',
      //   getComponent(nextState, cb) {
      //     require.ensure([], (require) =>
      //       cb(null, require('./containers/Booking/BookingPayment')));
      //   }

    }, {
      path: 'login',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Home/Home'));
        }, 'login');
      }
    }, {
      path: 'logout',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Logout/Logout'));
        }, 'logout');
      }
    }, {
      path: 'reset/:token',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Home/Home'));
        }, 'reset');
      }
    }, {
      path: 'trust-and-safety',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/TrustSafety/TrustSafety'));
        }, 'trust-safety');
      }
    }, {
      path: 'pachantiew',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Pachantiew/Pachantiew'));
        }, 'pachantiew');
      }
    }, {
      path: 'activity',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Activity/Activity'));
        }, 'activity');
      }
    }, {
      path: 'tour',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/TourType/TourType'));
        }, 'tour');
      }
    }, {
      path: 'city',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Cities/Cities'));
        }, 'city');
      }
    }, {
      path: 'review/:id',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/ManualReview/ManualReview'));
        }, 'review');
      }
    }, {
      path: 'sitemap',
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/Sitemap/Sitemap'));
        }, 'sitemap');
      }
    }, {
      path: '*',
      status: 404,
      getComponent: function getComponent(nextState, cb) {
        require.ensure([], function (require) {
          return cb(null, require('./containers/NotFound/NotFound'));
        }, 'not-found');
      }
    }]
  };
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/routes.js
// module id = 1706
// module chunks = 47